var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.Constants.ServerUrl + '/service/devize/fisa_pdf/' + _vm.IdDeviz + '/0',"width":"100%","height":_vm.parentHeight}}),(_vm.SemnaturaConsimtamant)?_c('img',{staticStyle:{"max-width":"300px","margin-top":"20px"},attrs:{"src":_vm.SemnaturaConsimtamant,"alt":"Semnătură"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }